import { AbstractListController } from "src/app/common/abstract-list.component";
import { Router, ActivatedRoute } from "@angular/router";
import { DynamicFiltersComponent } from "../../components/dynamic-filters/dynamic-filters.component";
import { Component, inject, signal } from "@angular/core";
import { BookingsService } from '../../services/bookings.service';
import { Blog } from '../../models/blog';
import { ConfirmationService, SelectItem, PrimeTemplate } from 'primeng/api';
import { CategoryService } from '../../services/categories.service';
import { Category } from '../../models/category';
import { MessageService } from 'primeng/api';
import { Clients } from 'src/app/models/clients';
import { ClientsService } from 'src/app/services/clients.service';
import { ComuniService } from 'src/app/services/comuni.service';
import { Comuni } from 'src/app/models/comuni';
import { WorksService } from 'src/app/services/works.service';
import { Works } from 'src/app/models/works';
import { LocationsService } from 'src/app/services/locations.service';
import { Locations } from 'src/app/models/locations';
import { Employees } from 'src/app/models/employees';
import { EmployeesService } from 'src/app/services/employees.service';
import { Bookings } from 'src/app/models/bookings';
import { formatDate } from '@angular/common';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { NgxSpinnerService } from "ngx-spinner";
import { SupportsService } from 'src/app/services/supports.service';
import { Supports } from 'src/app/models/supports';
import { PARAM_BOOKINGS_PATH, PARAM_SUPPORTS_PATH } from '../../constants/constants';
import { Bind } from 'primeng/bind';
import { Drawer } from 'primeng/drawer';
import { DatePicker } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { ButtonDirective } from 'primeng/button';
import { TopNavComponent } from '../../top-nav/top-nav.component';
import { RouterLink } from '@angular/router';
import { Card } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { NgxPaginationModule } from 'ngx-pagination';
import { ConfirmDialog } from 'primeng/confirmdialog';

import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-manage-supports',
    templateUrl: './manage-supports.component.html',
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, DatePicker, FormsModule, ButtonDirective, TopNavComponent, RouterLink, Card, TableModule, Tag, NgxPaginationModule, ConfirmDialog]
})
export class ManageSupportsComponent extends AbstractListController<Supports, any> {
  private clientsService = inject(ClientsService);

  title = "Supporto";
  readonly cols = signal<any[]>(undefined);
  readonly clients = signal<any>([]);
  readonly booking = signal<Bookings>(undefined);
  readonly selectedWorks = signal<any[]>(undefined);
  readonly roomDialog = signal<boolean>(false);

  constructor() {
    super(inject(SupportsService), inject(ConfirmationService), inject(Router), inject(ActivatedRoute), PARAM_SUPPORTS_PATH);

    this.cols.set([
      { field: "date", header: "Data" },
      { field: "title", header: "titolo" },
      { field: "category_id", header: "Cliente" },
    ]);
    this.colsFilter.set([
      { field: "title", icon: "pi-tag", header: "Titolo", type: "string" },
      { field: "date_gte", icon: "pi-calendar", header: "Dal", type: "date" },
      { field: "date_lte", icon: "pi-calendar", header: "Al", type: "date" },
    ]);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.getClients();
  }

  getCategoryItem(category_id: string) {
    return this.clients().find((item: any) => item.id === category_id);
  }

  getClients() {
    this.clientsService.getAllList().subscribe(
      (data: Clients) => this.clients.set(data),
      (error) => this.error.set(error),
    );
  }

  editRoom(booking: Bookings) {
    this.booking.set({ ...booking });
    this.selectedWorks.set((this.booking().works_id || "").split(","));
    this.roomDialog.set(true);
  }

  hideDialog() {
    this.roomDialog.set(false);
  }
}
